import {inspectOfflinePdf} from './offlinePdfReader';

// Comprobación previa a publicar la recuperación. Un hash correcto acredita
// identidad, pero no que el lector pueda interpretar el contenido.
export async function validateLegacyMediaReadability({file, bytes, mimeType}) {
    if (mimeType === 'application/pdf') {
        const result = await inspectOfflinePdf(file, bytes);
        if (!Number.isInteger(result.pages) || result.pages < 1) throw Error('No se pudo comprobar la lectura del PDF en este dispositivo. Se conserva pendiente de recuperación.');
        return {readable: true, reader: result.reader, pages: result.pages};
    }
    if (!/^image\/(png|jpeg|webp|gif|bmp|avif)$/i.test(mimeType || '')) throw Error('El formato de imagen requiere un lector compatible antes de recuperar la visita.');
    const url = URL.createObjectURL(new Blob([bytes], {type: mimeType}));
    try {
        return await new Promise((resolve, reject) => {
            const image = new Image(), timer = setTimeout(() => {image.src = ''; reject(Error('No se confirmó la lectura de la imagen.'));}, 15000);
            image.onload = () => {
                clearTimeout(timer);
                if (image.naturalWidth > 0 && image.naturalHeight > 0) resolve({readable: true, reader: 'image', width: image.naturalWidth, height: image.naturalHeight});
                else reject(Error('La imagen no tiene dimensiones legibles.'));
            };
            image.onerror = () => {clearTimeout(timer); reject(Error('El lector no puede abrir la imagen original. Se conserva pendiente de recuperación.'));};
            image.src = url;
        });
    } finally {URL.revokeObjectURL(url);}
}
